<div
    baasClickOutside
    (clickOutside)="outsideClicked()"
    [clickOutsideEnabled]="!showWaarom() && init()"
    class="happiness-meter mat-elevation-z24"
    [class.happiness-meter--minimized]="minimized()"
>
    @if (!minimized()) {
        <div class="opinion">Uw mening telt</div>
    }
    <div class="d-flex flex-column">
        @if (!minimized()) {
            <small class="mb-2 label-text" name="labeltext">{{ labelText() }}</small>
        }
        <div class="d-flex emotion-container">
            @for (emotion of emotions(); track emotion.value) {
                <button
                    mat-icon-button
                    (click)="onClickEmotion(emotion.value)"
                    [class.hapiness-icon-btn--active]="activeEmotion() === emotion.value"
                    [attr.aria-label]="emotion.name"
                    [color]="emotion.color"
                    class="happiness-icon-btn"
                >
                    <mat-icon [class]="[activeEmotion() === emotion.value ? 'fas' : 'far', emotion.class]"></mat-icon>
                </button>
            }
        </div>
        @if (showWaarom() && !minimized()) {
            <form [formGroup]="tevredenheidsForm">
                <mat-form-field class="w-100">
                    <mat-label>Waarom?</mat-label>
                    <mat-select multiple formControlName="reason">
                        @for (cat of lvCategories(); track cat.id) {
                            <mat-option [value]="cat.id"> {{ cat.omschrijving }} </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="w-100">
                    <mat-label>Wilt u verduidelijken?</mat-label>
                    <textarea rows="3" formControlName="comment" matInput maxlength="3900"></textarea>
                </mat-form-field>
                <p id="extra-info" class="text-muted">
                    <span [innerHtml]="verduidelijkingstext()"></span> Voor vragen over uw dossier: gebruik
                    <a
                        style="cursor: pointer; text-decoration: underline"
                        (click)="openMailOnsDialog()"
                        (keydown.enter)="openMailOnsDialog()"
                        (keydown.space)="openMailOnsDialog()"
                        tabindex="0"
                        >dit formulier</a
                    >
                </p>
                <button class="mb-3" matButton="filled" (click)="onClickSubmit()" type="submit">Doorsturen</button>
            </form>
        }
    </div>
</div>
